import React from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Content,
  StepCircle,
  ContainerCircles,
  Actions,
  Button,
  ContainerButtons,
  BackButton,
  LeftContainer,
  RightContainer,
  GrowCenter,
} from './styles';

const ModalSteps = (props) => {
  const {
    open,
    onClose,
    activeIndex,
    components,
  } = props;

  return (
    <Modal
      open={open}
      closeOnEscape
      closeOnDimmerClick
      onClose={onClose}
    >
      <Content>
        <ContainerCircles>
          {components.map((item, index) => (
            <StepCircle active={index === activeIndex} />
          ))}
        </ContainerCircles>
        {components[activeIndex].component}
      </Content>
      <Actions>
        <ContainerButtons>
          {components[activeIndex].onClickBack && (
            <LeftContainer>
              <BackButton
                onClick={components[activeIndex].onClickBack}
              >
                Back
              </BackButton>
            </LeftContainer>
          )}
          <GrowCenter />
          <RightContainer>
            <Button
              onClick={components[activeIndex].onClick}
              loading={components[activeIndex].loading}
            >
              {components[activeIndex].buttonText}
            </Button>
          </RightContainer>
        </ContainerButtons>
      </Actions>
    </Modal>
  );
};

ModalSteps.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  activeIndex: PropTypes.number.isRequired,
  components: PropTypes.array.isRequired,
};

ModalSteps.defaultProps = {
  open: false,
};

export default ModalSteps;
